import Plyr from 'plyr';
const videos = {
    playersClick: [] as Array<Plyr>,

    init() {
        this.videosInit()
        this.onClick()
        window.addEventListener("reset", this.videosInit)
    },

    videosInit() {
        const videosClick = document.querySelectorAll('.jsPlayerOnClick') as NodeListOf<HTMLElement>
        this.playersClick = Array.from(videosClick).map((p) => new Plyr(p));
    },
    
    onClick() {
        this.playersClick.forEach((item, index) => {
            const buttons = item.elements.buttons.play as HTMLButtonElement[];
            buttons.forEach(item => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                })
            })
            item.on("play", () => {
                this.playersClick.forEach((el, i) => {
                    if (index !== i) {
                        el.pause()
                    }
                })
            })
        })
    },

}

export default videos;